var map = {
	"./all_ears.svg": 708,
	"./another_brick.svg": 709,
	"./assessment.svg": 710,
	"./game.svg": 711,
	"./words_attack.svg": 712
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 908;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units ^\.\/.*\.svg$
// module id = 908
// module chunks = 10 11 17